import { observable, decorate, action } from 'mobx'
import axios from 'axios'

class UserStore {
  constructor (rootStore) {
    this.validateLogin()
    this.initialState = {
      id: '',
      name: '',
      companies: {
        branches: []
      },
      email: '',
      permissions: [],
      profiles: [],
      isAuthenticated: false
    }
    this.rootStore = rootStore.stores

    this.state = localStorage.userStoreState ? (
      JSON.parse(localStorage.userStoreState)
    ) : (
      this.initialState
    )

    if (localStorage.userStoreState) {
      const userStoreState = JSON.parse(localStorage.userStoreState)
      this.fetchUserInfo(userStoreState.id)
    }
  }

  resetState () {
    this.state = this.initialState
  }

  logout (event) {
    event.preventDefault()
    delete localStorage.userStoreState
    delete localStorage.loginDate
    delete localStorage.lastActivityDate
    window.location.reload()
  }

  fetchUserInfo (id) {
    const url = process.env.REACT_APP_AWS_URL + '/getUserInfo'
    axios.get(url, {
      params: {
        id
      }
    })
      .then(response => {
        this.state.id = id
        this.state.name = response.data.name
        this.state.email = response.data.email
        this.state.permissions = response.data.permissions
        this.state.profiles = response.data.profiles
        this.state.isAuthenticated = true
        this.getCompanyInfo(response.data.companies)
      })
      .catch(error => {
        console.log(error)
      })
  }

  getCompanyInfo (companies) {
    const url = process.env.REACT_APP_AWS_URL + '/getCompanyInfo'
    axios.post(url, {
      companies: companies
    })
      .then(response => {
        this.state.companies = response.data
        this.rootStore.nfeStore.setBranches(response.data[0].branches)
        const now = new Date()
        localStorage.loginDate = now.toISOString()
        localStorage.lastActivityDate = now.toISOString()
        localStorage.userStoreState = JSON.stringify(this.state)
      })
      .catch(error => {
        console.log(error)
      })
  }

  checkPermission (permission) {
    return this.state.permissions.some(val => val === permission)
  }

  validateLogin () {
    if (localStorage.loginDate) {
      const loginDate = new Date(localStorage.loginDate)
      const lastActivityDate = new Date(localStorage.lastActivityDate)
      const now = new Date()
      const secondsBetween = Math.abs((now.getTime() - loginDate.getTime()) / 1000)
      const lastActivitySeconds = Math.abs((now.getTime() - lastActivityDate.getTime()) / 1000)
      if (secondsBetween > 600 && lastActivitySeconds >= 60) {
        delete localStorage.userStoreState
        delete localStorage.loginDate
        delete localStorage.lastActivityDate
      } else {
        localStorage.lastActivityDate = now.toISOString()
      }
    }
  }
}

decorate(UserStore, {
  state: observable,
  setUserAttribute: action,
  resetState: action
})

export default UserStore



// WEBPACK FOOTER //
// ./src/stores/userStore.js